// 🖼️ عارض صور عام لكل واجهات الموظفين: أي صورة مرفوعة (رابط Storage، أو
// معاينة ملف قبل الحفظ blob:/data:) تنفتح بالكبير بضغطة، بأي صفحة - حتى
// الصفحات اللي ما سوّت إلها عارض خاص.
//
// ما يتدخل بالصور اللي إلها تصرف خاص أصلاً: إذا الصورة أو أقرب عناصر فوكها
// عدها onClick (مثل كارت فاتورة يفتح الفاتورة، أو مصغّرة تفتح معاينتها
// الخاصة)، أو داخل رابط/زر، تبقى على تصرفها. الشعارات والأيقونات (ملفات
// التطبيق نفسه) ما تنفتح. لاستثناء صورة معيّنة: data-no-viewer.
import React, { useEffect, useState } from "react";
import { Dialog, IconButton, Box, Button } from "@mui/material";

// الصور المرفوعة فقط - مو ملفات التطبيق (/logo.png، /static/media/...)
const isUploadedSrc = (src) => {
  if (!src) return false;
  if (src.startsWith("blob:") || src.startsWith("data:image")) return true;
  try {
    return new URL(src, window.location.href).origin !== window.location.origin;
  } catch {
    return false;
  }
};

// React يخزن الـprops على عنصر الـDOM بمفتاح __reactProps$... - نستخدمه بس
// حتى نعرف إذا العنصر إله onClick (فنحترم تصرفه)
const hasReactClick = (el) => {
  const key = Object.keys(el).find((k) => k.startsWith("__reactProps$"));
  return !!(key && el[key] && typeof el[key].onClick === "function");
};

// نفحص الصورة ولحد 4 عناصر فوكها، ونوقف عند حدود الـDialog (حاوية الـDialog
// عدها onClick للخلفية وما تعني إن الصورة إلها تصرف)
const MAX_DEPTH = 4;
const hasOwnBehaviour = (img) => {
  if (img.closest("a[href], button, [role='button'], [data-no-viewer]")) return true;
  let el = img;
  for (let depth = 0; el && depth <= MAX_DEPTH; depth += 1) {
    if (el.classList?.contains("MuiDialog-container") || el.classList?.contains("MuiModal-root")) break;
    if (hasReactClick(el)) return true;
    el = el.parentElement;
  }
  return false;
};

// صورة معروضة أصلاً بالكبير داخل نافذة (مثل نوافذ "📷 معاينة الصورة" بلوحات
// الموظفات) - ما نفتح فوكها عارض ثاني، لأن هذا يطلّع نافذتين فوق بعض.
// المصغّرات الصغيرة داخل النوافذ تبقى تنفتح بالعارض عادي
const isAlreadyEnlarged = (img) => {
  if (!img.closest(".MuiDialog-root, .MuiModal-root")) return false;
  const { width } = img.getBoundingClientRect();
  return width >= Math.min(480, window.innerWidth * 0.6);
};

const GlobalImageViewer = () => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    const onClick = (e) => {
      const img = e.target;
      if (!(img instanceof HTMLImageElement) || e.defaultPrevented) return;
      if (img.closest("[data-image-viewer]")) return;
      const imageSrc = img.currentSrc || img.src;
      if (!isUploadedSrc(imageSrc) || hasOwnBehaviour(img) || isAlreadyEnlarged(img)) return;
      setSrc(imageSrc);
    };
    // مؤشر "تكبير" على الصور اللي تنفتح، حتى يبين إنها تنضغط
    const onOver = (e) => {
      const img = e.target;
      if (!(img instanceof HTMLImageElement) || img.dataset.viewerChecked) return;
      img.dataset.viewerChecked = "1";
      if (!img.closest("[data-image-viewer]") && isUploadedSrc(img.currentSrc || img.src) && !hasOwnBehaviour(img) && !isAlreadyEnlarged(img)) {
        img.style.cursor = "zoom-in";
      }
    };
    document.addEventListener("click", onClick);
    document.addEventListener("mouseover", onOver);
    return () => {
      document.removeEventListener("click", onClick);
      document.removeEventListener("mouseover", onOver);
    };
  }, []);

  return (
    <Dialog
      open={!!src}
      onClose={() => setSrc(null)}
      maxWidth={false}
      data-image-viewer
      PaperProps={{ sx: { bgcolor: "transparent", boxShadow: "none", m: 1 } }}
    >
      <Box sx={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
        <IconButton
          onClick={() => setSrc(null)}
          aria-label="إغلاق"
          sx={{ position: "absolute", top: 8, right: 8, bgcolor: "rgba(0,0,0,0.6)", color: "#fff", "&:hover": { bgcolor: "rgba(0,0,0,0.8)" } }}
        >
          ✕
        </IconButton>
        {src && (
          <img
            src={src}
            alt="عرض الصورة"
            style={{ maxWidth: "95vw", maxHeight: "85vh", objectFit: "contain", borderRadius: 8, background: "#fff" }}
          />
        )}
        {src && !src.startsWith("blob:") && !src.startsWith("data:") && (
          <Button variant="contained" size="small" href={src} target="_blank" rel="noopener noreferrer">
            فتح بتبويب جديد
          </Button>
        )}
      </Box>
    </Dialog>
  );
};

export default GlobalImageViewer;
